import FloorPlanDetail from '../components/FloorPlanDetail';

export default function FloorPlan31Page() {
  const floorPlanData = {
    id: '3-1',
    title: '3+1 Örnek Daire',
    totalArea: '125 m²',
    rooms: '3 Yatak Odası + 1 Salon',
    image: '/plan-3-1.png',
    description: '3+1 daire tipimiz, geniş ailelerin konfor ve ferahlık ihtiyaçlarını karşılamak üzere özenle tasarlanmıştır. Geniş salon ve yemek alanı, üç konforlu yatak odası, iki banyo ve giyinme odası ile modern yaşamın tüm gereksinimlerini sunar. Ana yatak odasına özel giyinme odası ve banyo, günlük yaşamınıza ekstra konfor katar.',
    roomDetails: [
      { name: 'Salon', dimensions: '5.20 x 6.80 m', area: '35.36 m²' },
      { name: 'Mutfak', dimensions: '3.20 x 4.00 m', area: '12.80 m²' },
      { name: 'Ana Yatak Odası', dimensions: '4.00 x 4.80 m', area: '19.20 m²' },
      { name: 'Yatak Odası 1', dimensions: '3.40 x 3.80 m', area: '12.92 m²' },
      { name: 'Yatak Odası 2', dimensions: '3.20 x 3.60 m', area: '11.52 m²' },
      { name: 'Ana Banyo', dimensions: '2.40 x 3.00 m', area: '7.20 m²' },
      { name: 'Ebeveyn Banyosu', dimensions: '2.00 x 2.60 m', area: '5.20 m²' },
      { name: 'Giyinme Odası', dimensions: '2.20 x 2.80 m', area: '6.16 m²' },
      { name: 'Balkon', dimensions: '1.40 x 9.20 m', area: '12.88 m²' },
      { name: 'Koridor & Hol', dimensions: '-', area: '16.76 m²' }
    ],
    features: [
      'Çok geniş salon ve yemek alanı',
      'Ana yatak odasına özel giyinme odası',
      'İki ayrı banyo',
      'Üç konforlu yatak odası',
      'Geniş balkon alanı',
      'Açık mutfak konsepti',
      'Bol dolap alanları',
      'Merkezi ısıtma sistemi',
      'Yerden ısıtma',
      'Akıllı ev altyapısı',
      'Ses yalıtımı',
      'Isı yalıtımı'
    ]
  };

  return <FloorPlanDetail data={floorPlanData} />;
}